





































































import { apiService, AppConstants, Interfaces, Models, Utils } from "@/core/Export";
import store from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class AddEditAddition extends Vue {
  @Prop() model: Models.EmployeeExtra;
  @Prop() isCurrentUserAdditional: boolean;
  @Prop() employeeDayAdditionalReason: Array<any>;
  @Prop() hourTypes: Array<any>;
  @Prop({ default: [] }) nominations: Array<Models.TBaseItem>;
  @Prop({ default: false }) useNominations: boolean;
  @Prop({ default: async (value: any): Promise<void> => { } }) dateChanged: Function;

  empAdditionTypeCodes = AppConstants.EmpAdditionTypeCodes;
  limitMessage: string;
  limitMinMessage: number = 0;

  constructor() {
    super();
  }

  created(): void {
    this.runEmpNominationsLogic();
  }

  public runEmpNominationsLogic(isFromDateChange: boolean = false): void {
    if (!this.useNominations) {
      this.model.nominationId = 0;
      return;
    }

    if (this.nominations.length > 0) {
      if (this.model.nominationId != 0) {
        if (isFromDateChange) {
          let isExist: boolean = Boolean(this.nominations.find(q => q.id === this.model.nominationId));
          if (isExist) return;

          this.setDefaultEmployeeNomination();
        }

        return;
      }

      this.setDefaultEmployeeNomination();
    }
  }

  public setDefaultEmployeeNomination(): void {
    this.model.nominationId = this.nominations[0].id;
  }

  public onSave(): void {
    if (!this.validateForm(this.model)) return;
    let lines = new Array<Models.EmployeeExtra>();
    lines.push(this.model);

    this.appEnv.isBusy = true;
    apiService
      .saveEmployeeDayAdditional(
        this.drawerParams.employeeId,
        this.drawerParams.date,
        lines,
        this.model.nominationId
      )
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          Utils.Notification.notifyPositive(this.$t("msgs.save").toString(), "thumb_up");
          this.$emit("closeDrawer");
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      })
      .finally(() => {
        this.appEnv.isBusy = false;
      });
  }

  setDefaultData() {
    const reasonObj = this.getReasonDataById();
    this.model.valueTypeCode = reasonObj.valueTypeCode;
    this.model.hourTypeId =
      reasonObj.valueTypeCode == this.empAdditionTypeCodes.Time
        ? reasonObj.hourType
        : 0;
    this.model.valueText = reasonObj.valueText;
    this.model.notes = reasonObj.notes;
    this.resetFormFields();
  }

  resetFormFields(): void {
    let destinationFrom = this.$refs.destinationFrom as any;
    destinationFrom.resetValidation();
    destinationFrom.isDirty = false;
    let destinationTo = this.$refs.destinationTo as any;
    destinationTo.resetValidation();
    destinationTo.isDirty = false;
  }

  getReasonDataById() {
    return this.employeeDayAdditionalReason.find(
      (x) => x.id == this.model.employeeDayAdditionalReasonId
    );
  }

  public async onDateChanged(e: any): Promise<void> {
    let qFromDateProxy: any = this.$refs.qFromDateProxy;
    qFromDateProxy.hide();
    await this.dateChanged(this.drawerParams.date);
    this.runEmpNominationsLogic(true);
  }

  onFromTimeChanged(e) {
    this.model.valueText = Models.AppUtils.formatTime(e.target.value);
  }

  checkMaxLimitRule(val) {
    const reasonObj = this.getReasonDataById();
    if (reasonObj && reasonObj.maxValueText && reasonObj.maxValueText > 0) {
      if (
        reasonObj.valueTypeCode == this.empAdditionTypeCodes.Time &&
        reasonObj.maxValueText < val
      ) {
        this.limitMessage = reasonObj.maxValueText;
        return false;
      } else if (
        reasonObj.valueTypeCode != this.empAdditionTypeCodes.Time &&
        +reasonObj.maxValueText < val
      ) {
        this.limitMessage = reasonObj.maxValueText;
        return false;
      }
    }
    return true;
  }

  validateForm(model: Models.EmployeeExtra): boolean {
    if (model.valueTypeCode == this.empAdditionTypeCodes.KM)
      return this.checkAmountRule(model.valueText) && this.checkDestinationFromRule(model.destinationFrom) && this.checkDestinationToRule(model.destinationTo);
    return true;
  }

  checkAmountRule(val: string): boolean {
    let num = parseFloat(val);
    if (val && num <= 0) return false;
    return true;
  }
  checkDestinationFromRule(val: string): boolean {
    const reasonObj = this.getReasonDataById();
    if (reasonObj.isOriginMandatory) {
      if (!!val)
        return true;
      return false;
    }
    return true;
  }

  checkDestinationToRule(val: string): boolean {
    const reasonObj = this.getReasonDataById();
    if (reasonObj.isDestinationMandatory) {
      if (!!val)
        return true;
      return false;
    }
    return true;
  }

  public get isNominationsSelectIsDisabled() {
    return this.drawerParams.employeeId != this.appEnv.UserInfo.employeeId;
  }

  public get drawerParams() {
    return store.getters.drawerParams;
  }
  public get appEnv() {
    return store.state.appEnv;
  }
}
